var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRestHalfWhole = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 51 135",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#512D1C",
  d: "M0 55h51v25H0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRestHalfWhole);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rest-half-whole.236bfa794a596bf54e9d59a612d1aeb9.svg";